// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","904":"component---src-pages-blog-mcp-development-tsx"}[chunkId] || chunkId) + "-" + {"245":"d8da640166c1e2b2f347","453":"323e4634f6d6fbe28553","522":"a03354ce59a119664ae6","904":"2a6713c54d0c2081b10c"}[chunkId] + ".js";
};